import React, { Fragment, ReactElement, useMemo } from 'react'
import { TextLabel } from '@copyrightagent/basic-components'
import { useTranslation } from 'react-i18next'
import { ICase } from 'lib/entities/Case'
import { useStyle } from './style'

export default function LocationLabel({
	theCase,
}: {
	theCase: ICase
}): ReactElement | null {
	const classes = useStyle()
	const { t } = useTranslation()

	const InReviewLabel = useMemo(
		() => (
			<TextLabel
				uppercase
				size="small"
				labelText={t('caseRow/labels/inReview')}
				className={classes.chip}
			/>
		),
		[classes, t],
	)

	const OnHoldLabel = useMemo(
		() => (
			<TextLabel
				uppercase
				size="small"
				labelText={t('caseRow/labels/onHold')}
				color="blue"
			/>
		),
		[classes, t],
	)

	function displayLabel(): ReactElement | undefined {
		if (theCase.state !== 'client_approval') return
		if (theCase.on_hold) return OnHoldLabel
		return InReviewLabel
	}

	return <Fragment>{displayLabel()}</Fragment>
}
